<template>
  <TournamentAgeCategoryForm :isEdit="true" :classId="$route.params.id" />
</template>
  
  <script>
  import TournamentAgeCategoryForm from '@/components/tournament-age-category/AgeCategoryForm.vue';
  
  export default {
    name: "TournamentAgeCategoryEditPage",
    components: {
      TournamentAgeCategoryForm,
    },
  };
  </script>
  